import React from 'react'
import moment from 'moment'
import { ScrollSyncPane } from 'react-scroll-sync'
import { NavLink } from 'react-router-dom'

const OrderRow = (props) => {
  return (
    <div className='reservation_row'>
      { props.reservation &&
        props.reservation['attributes'] &&
      <div className='reservation_row_wrapper'>
        <div className='order_col_one'>
        </div>
        <div className='column-one order_col created_at'>
          <div>
            { moment(props.reservation.attributes['pickUpDate']).format('MM/DD/YYYY') }
          </div>
        </div>
        <ScrollSyncPane>
          <div className='scroll'>
            <div className='name order_col'>
              <div className='first_name'>
                <div>
                  <NavLink to={`/reservations/${props.reservation.id}`}>
                    <div>
                      { props.reservation.attributes['fullName'] }
                    </div>
                  </NavLink>
                </div>
              </div>
            </div>
            <div className='street_address order_col'>
              <div>
                { props.reservation.attributes['customerStreetAddress'] }
              </div>
            </div>
            <div className='email order_col'>
              <div>
                { props.reservation.attributes['customerEmail'] }
              </div>
            </div>
            <div className='phone_number order_col_last order_col'>
              <div>
                { props.reservation.attributes['customerPhoneNumber'] }
              </div>
            </div>
          </div>
        </ScrollSyncPane>
      </div>
      }
    </div>
  )
}

export default OrderRow



// WEBPACK FOOTER //
// ./src/Reservations/OrderRow.jsx